import { PAYMENT_DONE_PARAMETER } from "modules/BookingCommon/common/constants"
import { APP_STATUSES } from "utils/AppStatusContext"

export function basePaymentUrl(
    searchParams: URLSearchParams | Map<string, string | null>,
    hash_id: string,
    isPaymentDone = true
) {
    const params: Record<string, string> = {
        hash_id,
    }
    if (isPaymentDone) {
        params[PAYMENT_DONE_PARAMETER] = "1"
    }
    if (searchParams.get("subsequent") === "1") {
        params.subsequent = "1"
    }
    if (searchParams.get("from") === APP_STATUSES.client_account) {
        params.from = APP_STATUSES.client_account
    }

    return params
}
